/**
 * Validates a Swiss AVS/AHV number (NAVS13).
 * Format: 756.XXXX.XXXX.XX (13 digits, prefix 756, EAN-13 check digit)
 *
 * Frontend normalisation is more permissive than backend (strips dots, spaces, dashes).
 * Backend (digital-payroll) only strips dots. Use normalizeAvsNumber() to convert
 * user input to raw digits before sending to the API.
 */
export function normalizeAvsNumber(value: string): string {
  return value.replace(/[\s.\-]/g, '')
}

export function formatAvsNumber(value: string): string {
  const digits = normalizeAvsNumber(value)
  if (digits.length !== 13) return value
  return `${digits.slice(0, 3)}.${digits.slice(3, 7)}.${digits.slice(7, 11)}.${digits.slice(11, 13)}`
}

export function isValidAvsNumber(value: string): boolean {
  // Normalize: strip dots, spaces, dashes for validation
  const digits = normalizeAvsNumber(value)

  // Must be exactly 13 digits
  if (!/^\d{13}$/.test(digits)) return false

  // Must start with 756
  if (!digits.startsWith('756')) return false

  // EAN-13 check digit validation
  // Weights alternate 1, 3 from left to right on first 12 digits
  let sum = 0
  for (let i = 0; i < 12; i++) {
    const weight = i % 2 === 0 ? 1 : 3
    sum += parseInt(digits[i], 10) * weight
  }

  const checkDigit = (10 - (sum % 10)) % 10
  return checkDigit === parseInt(digits[12], 10)
}
